export enum ClubWeb3Model {
  KRIPTOWN = 'KRIPTOWN',
  NONE = 'NONE',
  OFF_CHAIN = 'OFF_CHAIN',
}
